import {Button} from "../controlElements/Button";

export class AutoPlayButton extends Button {

    private readonly LABEL_POISTION = new PIXI.Point(0, -5);
    private readonly LABEL_STYLE = {
        fontSize: 20,
        fontFamily: "RobotoRegular",
        fill: "#fff",
    };

    constructor(base: string, onHover: string, onClick: string, inactive: string, soundName: string) {

        super(base, onHover, onClick, inactive, soundName);

        this.initializeLabel();
    }

    public setSpinsLeftValue(amount: number): void {
        if (amount === 0) {
            this.label.text = "";
        } else {
            this.label.text = "" + amount;
        }
    }

    private initializeLabel(): void {
        this.label = new PIXI.Text("", this.LABEL_STYLE);
        this.label.position = this.LABEL_POISTION;
        this.label.anchor = this.DEFAULT_ANCHOR_POINT;
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/AutoPlayButton.ts